import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useAvailabilityConstraintHistories } from 'hooks'
import { useTranslation } from 'react-i18next'
import { HistoryTable } from './HistoryTable'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const PAGE_SIZE = 50

const HistoryModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation()

  const { data, isError, isLoading } = useAvailabilityConstraintHistories(
    {
      page_size: PAGE_SIZE,
      sort: 'desc',
      sort_by: 'created_at',
    },
    { enabled: isOpen }
  )

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>
        <Typography variant="h2">{t('pages.settings.resources.availabilityConstraints.modal.constraints_history.title')}</Typography>
        {!isLoading && (
          <Typography variant="caption">
            {t('pages.settings.resources.availabilityConstraints.modal.constraints_history.subtitle', {
              showing: data?.data?.length ?? 0,
              total: data?.meta?.items_total,
            })}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <HistoryTable isError={isError} isLoading={isLoading} history={data} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export { HistoryModal }
